import { Input, Radio, RadioInputs } from "@deligoo/ui"
import { unwrapResult } from "@reduxjs/toolkit"
import { useState } from "react"
import { toast } from "react-toastify"

import { useAppDispatch } from "@/App"
import { ConfirmModal } from "@/components/ConfirmModal"
import { requestOrderReturn } from "@/store/orders"
import { Order } from "@/types"

type OrderReturnModalProps = {
  orderId: Order["id"]
  handleClose: () => void
}

export const OrderReturnModal = ({ orderId, handleClose }: OrderReturnModalProps) => {
  const [isLoading, setLoading] = useState(false)
  const [returnReason, setReturnReason] = useState("")
  const [withAdditionalFee, setWithAdditionalFee] = useState<boolean>()

  const dispatch = useAppDispatch()

  async function handleReturnOrder() {
    const toastSettings = {
      toastId: "returnOrder",
      updateId: "returnOrder",
    }

    if (withAdditionalFee === undefined) {
      toast.error("Należy wybrać typ zwrotu", toastSettings)
      return
    }

    if (returnReason.length < 3) {
      toast.error("Powód zwrotu jest zbyt krótki", toastSettings)
      return
    }

    setLoading(true)

    const res = await dispatch(
      requestOrderReturn({
        orderId,
        body: {
          return_reason: returnReason,
          with_additional_fee: withAdditionalFee,
        },
      })
    ).then(unwrapResult)

    if (res.ok) {
      toast.success(`Zlecenie zostało zwrócone do nadawcy.`, toastSettings)
    } else {
      toast.error(`Nie udało się zwrócić zlecenia do nadawcy. Spróbuj ponownie później.`, toastSettings)
    }

    setLoading(false)
    handleClose()
  }

  return (
    <ConfirmModal
      title="Zwrot do nadawcy"
      isLoading={isLoading}
      handleConfirm={handleReturnOrder}
      handleClose={handleClose}
    >
      <RadioInputs>
        <Radio
          color="success"
          onChange={(e) => setWithAdditionalFee(e.currentTarget.checked)}
          name="additional_fee"
          id="withFee"
          required
        >
          Odpłatny
        </Radio>

        <Radio
          color="success"
          onChange={(e) => setWithAdditionalFee(!e.currentTarget.checked)}
          name="additional_fee"
          id="withoutFee"
          required
        >
          Nieodpłatny
        </Radio>
      </RadioInputs>

      <Input
        className="mt-6"
        placeholder="Powód zwrotu"
        onChange={(e) => setReturnReason(e.currentTarget.value)}
        plain
        required
        autoFocus
      />
    </ConfirmModal>
  )
}
